import {HttpErrorResponse} from '@angular/common/http';
import {createAction, props} from '@ngrx/store';
import {
    IGenerateActivityFormData
} from '../../../../contract-control/modals/bulk-upload-modal/ai-generate-activity/ai-generate-activity.component';
import {IUploadMapping} from '../../../../contract-control/modals/bulk-upload-modal/steps/match-columns-step/match-columns-step.component';
import {
    IImportPDFMapping
} from '../../../../contract-control/modals/bulk-upload-modal/steps/match-contract-cards-step/match-contract-cards-step.component';
import {
    IFirstLineTitlesResponseDTO,
    IGetPotentialMappingResponseDTO,
    IImportResponseDTO,
    ISaveMappingResponseDTO,
    IUploadXLSFileResponseDTO
} from '../../../../contract-control/modals/bulk-upload-modal/upload-files.service';
import {documentsBulkUploadConfig} from './documents-bulk-upload.config';
import {DocumentBulkUploadStepEnum} from './documents-bulk-upload.reducers';

const scope = `${documentsBulkUploadConfig}`

export const resetState = createAction(`${scope} Reset State`);
export const changeStep = createAction(`${scope} Change Step`, props<{ step: DocumentBulkUploadStepEnum }>());
export const nextStep = createAction(`${scope} Next Step`);
export const prevStep = createAction(`${scope} Prev Step`);

export const skipCSVImportClicked = createAction(`${scope}  Skip CSV import clicked`);
export const createImport = createAction(`${scope}  Create Import`);
export const createImportSucceed = createAction(`${scope}  Create Import Succeed`, props<{ importData: IUploadXLSFileResponseDTO }>());
export const createImportFailed = createAction(`${scope}  Create Import Failed`, props<{ error: HttpErrorResponse }>());

export const fetchPreviewPDFImportSucceed = createAction(`${scope}  Fetch Preview PDF Import Succeed`, props<{
    preview: any
}>());
export const fetchPreviewPDFImportFailed = createAction(`${scope}  Fetch Preview PDF Import Failed`, props<{
    error: HttpErrorResponse
}>());


export const changeStepResult = createAction(`${scope} Change Step Result`, props<{
    step: DocumentBulkUploadStepEnum
}>());
export const updateFirstLineTitles = createAction(`${scope} Update First Line Titles`, props<{
    firstLineTitles: 0 | 1
}>());
export const mergeOrganisationsChanged = createAction(`${scope} Merge Organisations Changed`, props<{
    mergeOrganisations: boolean
}>());
export const updateUploadId = createAction(`${scope} Update Upload Id`, props<{
    id: number
}>());

export const fetchFirstRow = createAction(`${scope} Fetch Firs Row`);
export const fetchFirstRowSucceed = createAction(`${scope} Fetch Firs Row Succeed`, props<{firstLine: IFirstLineTitlesResponseDTO }>());
export const fetchFirstRowFailed = createAction(`${scope} Fetch Firs Row Failed`,  props<{
    error: HttpErrorResponse
}>());

export const fetchPotentialMappings = createAction(`${scope} Fetch Potential Mappings`);
export const fetchPotentialMappingsSucceed = createAction(`${scope} Fetch Potential Mappings Succeed`, props<{mapping: IGetPotentialMappingResponseDTO}>());
export const fetchPotentialMappingsFailed = createAction(`${scope} Fetch Potential Mappings Failed`,  props<{
    error: HttpErrorResponse
}>());

export const mappingChanged  = createAction(`${scope} Mapping Changed`, props<{mapping: IUploadMapping[]}>());

export const saveMappings = createAction(`${scope} Save Mappings`);
export const saveMappingsSucceed = createAction(`${scope} Save Mappings Succeed`, props<{ mapping: ISaveMappingResponseDTO}>());
export const saveMappingsFailed = createAction(`${scope} Save Mappings Failed`,  props<{
    error: HttpErrorResponse
}>());
export const resetIsUpdateMappingRequestInProgress  = createAction(`${scope} Reset Is Update Mapping Request In Progress`);
 

export const importXLS = createAction(`${scope} Import XLS`);
export const importXLSSucceed = createAction(`${scope} Import XLS Succeed`, props<{ result: IImportResponseDTO}>());
export const importXLSFailed = createAction(`${scope} Import XLS Failed`,  props<{
    error: HttpErrorResponse
}>());

export const failedImportsChanged  = createAction(`${scope} Bulk Upload Actions`,  props<{
    items: IImportPDFMapping[]
}>());


export const importPDF = createAction(`${scope} Import PDF`);
export const importPDFSucceed = createAction(`${scope} Import PDF Succeed`, props<{ importData: any}>()); //TODO: set up view
export const importPDFFailed = createAction(`${scope} Import PDF Failed`,  props<{
    error: HttpErrorResponse
}>());

export const closeModal  = createAction(`${scope} Close Modal`);

export const setImportSettings  = createAction(`${scope} Set Import Settings`, props<{importSettings:IGenerateActivityFormData}>());
export const saveImportSettings  = createAction(`${scope} Save Import Settings`);
export const saveImportSettingsSucceed  = createAction(`${scope} Save Import Settings Succeed`);
export const saveImportSettingsFailed  = createAction(`${scope} Save Import Settings Failed`, props<{error:HttpErrorResponse}>());
